import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { resolveWorkspaceCourseId } from './workspacePresentation';

// Course discovery belongs to the signed-in workspace, not to each tab change.
export default function useWorkspaceCourses({ api, userId, role, search }) {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState('');
    const [loading, setLoading] = useState(true);
    const latestSearch = useRef(search);
    latestSearch.current = search;

    useEffect(() => {
        let active = true;
        setCourses([]);
        setSelectedCourse('');
        setLoading(true);
        axios.get(`${api}/courses`).then(res => {
            if (!active) return;
            setCourses(res.data);
            setSelectedCourse(current => resolveWorkspaceCourseId({
                courses: res.data,
                current,
                search: latestSearch.current,
                role,
            }));
            setLoading(false);
        }).catch(() => {
            if (active) setLoading(false);
        });
        return () => { active = false; };
    }, [api, userId, role]);

    return { courses, selectedCourse, setSelectedCourse, loading };
}
